<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    computedOpenDialog() {
      return this.dialog
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="computedOpenDialog"
    width="400"
    overlay-color="#ffffff"
    content-class="round_dialog_comfirm"
    persistent
  >
    <v-card color="#adc8e8" class="pb-7 pl-7 pr-7">
      <p class="pt-7">{{ title }}</p>
      <div class=" d-flex justify-space-between mt-7 mx-5">
        <slot></slot>
      </div>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
@import '@design';
.round_dialog_comfirm {
  border-radius: 20px !important;
}
.custom_height_comfirm {
  height: 32px !important;
}
.custom_width_comfirm {
  width: 100px !important;
}
</style>
